(() => {
  let queued = false;

  const important = (element, property, value) => {
    if (element) element.style.setProperty(property, value, 'important');
  };

  const centerCloudPrices = () => {
    document.querySelectorAll([
      '.cloud-search-filters-products .sxt-price-grid',
      '.cloud-search-filters-products .cs-price-block',
      '.template-search #product-grid .sxt-price-grid',
      '.template-search #product-grid .cs-price-block',
      '.sxt-search-page #product-grid .sxt-price-grid',
      '.sxt-search-page #product-grid .cs-price-block',
      '#cloud_search_filters_root .product-grid .sxt-price-grid',
      '#cloud_search_filters_root .product-grid .cs-price-block'
    ].join(',')).forEach((price) => {
      important(price, 'display', 'grid');
      important(price, 'width', '100%');
      important(price, 'max-width', 'none');
      important(price, 'margin-left', 'auto');
      important(price, 'margin-right', 'auto');
      important(price, 'justify-content', 'center');
      important(price, 'justify-items', 'center');
      important(price, 'text-align', 'center');

      const information = price.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]');
      important(information, 'width', '100%');
      important(information, 'max-width', 'none');
      important(information, 'text-align', 'center');

      price.querySelectorAll('.sxt-price-now, .sxt-price-reference, .price, s').forEach((line) => {
        important(line, 'margin-left', 'auto');
        important(line, 'margin-right', 'auto');
        important(line, 'justify-content', 'center');
        important(line, 'text-align', 'center');
      });
    });
  };

  const enhance = () => {
    queued = false;
    centerCloudPrices();
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  };

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cloud-search:render', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
